/**
 * Created by jonas on 2024-02-26.
 */
import {
    ActionSpinOptions, ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {StarStruckGameMode} from "./gamemode/StarStruckGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {StarStruck} from "./StarStruck";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StarStruckSoundConfig} from "./StarStruckSoundConfig";

export class StarStruckPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    getActionSpinOptions():ActionSpinOptions {
        return {
            gameName: "Start Struck",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "Game_BG"},
            automaticPickGame: {
                header: () => StarStruck.api.translations.translate("Note: Features will be auto-selected during bonus trigger."),
                optionSelection: (response: any) => {
                    return MathHelper.randomIntInRange(0,7);
                },
                type: ASBonusPickOptions.PICK_MODE,
                pickNeededForModes: [StarStruckGameMode.STAR_PICK],
                pickNeededForBuyFeatures: []
            },
            getParsedData: (response: any, bet: number, prevResponse: any):ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any): boolean {

        let win = response.totalSpinWinnings;

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response: any): boolean {
        return response.mode === GameMode.NORMAL && response.nextMode === StarStruckGameMode.STAR_PICK;
    }

    private getFeatureName(response: any): string {

        if ((response.mode == StarStruckGameMode.STAR_PICK) || response.nextMode == StarStruckGameMode.STAR_PICK){
            return "STARSTRUCK";
        }

        return "";
    }

    private isRoundComplete(response: any): boolean {
        return ([GameMode.NORMAL, StarStruckGameMode.STAR_PICK].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return (response.nextMode === GameMode.NORMAL && response.mode == StarStruckGameMode.STAR_PICK);
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(StarStruckSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(StarStruckSoundConfig.instance.AS_WIN_BIG);
        }
    }




}